var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2959 10.8826V2.2316L4.9659 4.56185L4.2579 3.84277L7.7959 0.304382L11.3339 3.84277L10.6269 4.56285L8.2959 2.2316V10.8826H7.2959ZM2.4109 14.3059C1.9509 14.3059 1.5669 14.1519 1.2589 13.8439C0.950232 13.5352 0.795898 13.1508 0.795898 12.6908V10.2675H1.7959V12.6908C1.7959 12.8441 1.8599 12.9851 1.9879 13.1138C2.11656 13.2418 2.25756 13.3058 2.4109 13.3058H13.1809C13.3342 13.3058 13.4752 13.2418 13.6039 13.1138C13.7319 12.9851 13.7959 12.8441 13.7959 12.6908V10.2675H14.7959V12.6908C14.7959 13.1508 14.6419 13.5348 14.3339 13.8429C14.0252 14.1516 13.6409 14.3059 13.1809 14.3059H2.4109Z",
    fill: "#EE3A24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.3fcaed0b414b5cd6a1947a28a34ef67c.svg";
export { ForwardRef as ReactComponent };